import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { Button, Container, Table } from 'react-bootstrap'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import { BiInfoCircle } from 'react-icons/bi'
import { BsDownload } from 'react-icons/bs'
import { connect } from 'react-redux'
import { useLocation } from "react-router-dom"
import {
  ExportChargingSessionsReport, getAllChargeSessions
} from '../../../store/actions/reports/charging'
import { getFormattedDate } from '../../../utils/common-methods'
import MapAdddressByLocation from '../../helpers/hoc/latlong-to-address-map/MapAddressByLocation'
import Loader from '../../helpers/hoc/loader/Loader'
import BreakdownBadge from '../../helpers/hoc/common-components/BreakdownBadge'
import MultiSelect from '../../helpers/hoc/mult-select/MultiSelect'
import NoRecordFound from '../../helpers/hoc/noRecordFound'
import Pagination from '../../helpers/hoc/paginator/Pagination'
import './css/ChargingLog.css'
import { Report_Filter_Type } from '../../../utils/constants'
import { GetUserRoleList } from '../../../store/actions/roleAndMenuMapping'
import SingleSelect from '../../helpers/hoc/single-select/SingleSelect'
import DatePicker from '../../helpers/hoc/date-picker/DatePicker'
import { mapper } from '../../../utils/mapper'
import VehicleNRNTooltip from '../../helpers/hoc/common-components/vehicle-nrn'

const Charge = ({
  //actions
  getAllChargeSessions,
  ExportChargingSessionsReport,
  GetUserRoleList,

  //states
  allChargingSessions,
  dataCount,
  isLoading,
  subscribedByCI,
}) => {
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [intervalDuration, setIntervalDuration] = useState()
  const [selectedOptions, setSelectedOptions] = useState([])
  const [isSubmitClicked, setIsSubmitClicked] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [coordinate, setCoordinate] = useState();
  const [filterType, setFilterType] = useState(Report_Filter_Type.VEHICLE)
  const [selectedOemModel, setSelectedOemModel] = useState([])
  const [selectedCity, setSelectedCity] = useState(null)
  const [clearDateSelection, setClearDateSelection] = useState(false)

  const ITEMS_PER_PAGE = 8
  const MaxVehicleLimit = 51

  const mappedOptions = mapper.mapVehicleDataOptions(subscribedByCI);

  useEffect(() => {
    if (mappedOptions.registrationNumber.length) {
      const queryParams = new URLSearchParams(location.search);
      const selectedVehicle = mappedOptions.registrationNumber.filter(x => x.label === queryParams.get('vehicleNumber'))
      setSelectedOptions(selectedVehicle)
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscribedByCI, location.search])

  useEffect(() => {
    if (dataCount > 0) {
      getAllChargeSessions({
        registrationNumbers: selectedOptions,
        fromDate: startDate,
        toDate: endDate,
        pageIndex: currentPage - 1,
        pageSize: ITEMS_PER_PAGE,
        intervalDuration: intervalDuration,
        oemModels: selectedOemModel?.map((item)=>item?.label),
        cities: selectedCity?.value ? [selectedCity?.value] : []
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage])

  const calculateIntervalDuration = (fromDate, toDate) => {
    const from = new Date(fromDate)
    const to = new Date(toDate)
    const diff = Math.abs(to - from)
    const minutes = Math.floor((diff / 1000) / 60)

    //for less than 1 day return 1 hr
    if (minutes < 1440) return 120
    //for less than 3 days return 4 hrs
    else if (minutes < 4320) return 240
    //for less than 7 days return 12 hrs
    else if (minutes < 10080) return 720
    //for less than 16 days return 1 day
    else if (minutes < 23040) return 1440
    //for greater than 16 days return 2 day
    return 2880
  }

  function onSelectionChange() {
    allChargingSessions.length = 0;
  }

  useEffect(() => {
    GetUserRoleList()
  }, [GetUserRoleList])

  const onSubmitHandler = () => {
    setCurrentPage(1)
    getAllChargeSessions({
      registrationNumbers: selectedOptions,
      fromDate: startDate,
      toDate: endDate,
      intervalDuration: intervalDuration,
      pageIndex: 0,
      pageSize: ITEMS_PER_PAGE,
      oemModels: selectedOemModel?.map((item)=>item?.label),
      cities: selectedCity?.value ? [selectedCity?.value] : []
    })
    setTimeout(() => {
      setIsSubmitClicked(true)
    }, 1000)
  }

  function exportToExcel() {
    ExportChargingSessionsReport({
      registrationNumbers: selectedOptions,
      fromDate: startDate,
      toDate: endDate,
      oemModels: selectedOemModel?.map((item)=>item?.label),
      cities: selectedCity?.value ? [selectedCity?.value] : []
    })
  }

  function renderTooltip(props) {
    return (
      <Tooltip className="tooltip" id="button-tooltip" {...props}>
        {props.parameter1}: {props.start}
        {props?.unit ? props.unit : ''} <br />
        {props.parameter2}: {props.end}
        {props?.unit ? props.unit : ''}
      </Tooltip>
    )
  }
  const handleMapCoOrdinateClick = (event) => {
    setShowPopup(true);
    setCoordinate(event);
  };

  const togglePopup = () => {
    setShowPopup((prevState) => !prevState);
  };

  const onDateChange = (date) => {
    setStartDate(date[0])
    setEndDate(date[1])
    setIntervalDuration(calculateIntervalDuration(startDate, endDate))
  }

  useEffect(() => {
    if(Report_Filter_Type.VEHICLE === filterType) {
      setSelectedOemModel([])
      setSelectedCity(null)
    } else {
      setSelectedOptions([])
    }
    setStartDate(null)
    setEndDate(null)
    setClearDateSelection(true);
		setTimeout(() => {
			setClearDateSelection(false);
		}, 500);

  }, [filterType])

  const isDisabled = () => {
    if(Report_Filter_Type.VEHICLE === filterType) {
      return !(selectedOptions !== null && selectedOptions?.length > 0 && startDate !== null && endDate !== null) || selectedOptions?.length >= MaxVehicleLimit
    } else {
      return !(selectedOemModel !== null && selectedOemModel?.length > 0 && selectedCity !== null && startDate !== null && endDate !== null)
    }
  }

  return (
    <>
      <Container fluid>
      <div className='col-12'>
              <span>
                <input
                  className="form-check-input"
                  type="radio"
                  name={"chargeFilterType"}
                  id={"chargeFilterType"}
                  checked={filterType === Report_Filter_Type.VEHICLE}
                  onChange={() => { setFilterType(Report_Filter_Type.VEHICLE); onSelectionChange(); }}
                  data-testid={`vehicle-type-radio-button`}
                />
                <text className="radio-checkbox-text-heading">
                    {Report_Filter_Type.VEHICLE}
                </text>
              </span>
              &nbsp;&nbsp;
              <span>
                <input
                  className="form-check-input"
                  type="radio"
                  name={"chargeFilterType"}
                  id={"chargeFilterType"}
                  checked={filterType === Report_Filter_Type.OEM_MODEL_CITY}
                  onChange={() => { setFilterType(Report_Filter_Type.OEM_MODEL_CITY); onSelectionChange(); }}
                  data-testid={`oem-model-radio-button`}
                />
                <text className="radio-checkbox-text-heading">
                    {Report_Filter_Type.OEM_MODEL_CITY}
                </text>
              </span>
      </div>
        <div className="row d-flex chargeLogsFilter">

          <div className={`col-3 multi-select-width ${!selectedOptions[0] ? 'no-value-selected' : ''}`}
          style={{display: filterType === Report_Filter_Type.VEHICLE ? 'block': 'none'}}>
            <MultiSelect
               options={mappedOptions.registrationNumber}
               selectedOptions={selectedOptions}
               setSelectedOptions={setSelectedOptions}
               isMultiSelect={true}
               onChange = {onSelectionChange}
               customBackgroundColor='#EFF3F7'
               webkitScrollbarWidth='5px'
               webkitScrollbarHeight='5px'
               minHeight='45px'
               placeholderAlignment='flex-start'
               indicatorSeparatorDisplay='none'
               placeholderColor='#C6C6C6'
               valueContainerColor="#797694" 
               data-testid='vehicle-filter'
               maxOptionSelectionLimit={MaxVehicleLimit}
              />
          </div>

          <div className={`col-3 multi-select-width ${!selectedOemModel[0] ? 'no-value-selected' : ''}`}
          style={{display: filterType === Report_Filter_Type.OEM_MODEL_CITY ? 'block': 'none'}}>
             <MultiSelect
               options={mappedOptions.oemModel}
               selectedOptions={selectedOemModel}
               placeholder='OEM & Model'
               setSelectedOptions={setSelectedOemModel}
               isMultiSelect={true}
               onChange = {onSelectionChange}
               customBackgroundColor='#EFF3F7'
               webkitScrollbarWidth='5px'
               webkitScrollbarHeight='5px'
               minHeight='45px'
               placeholderAlignment='flex-start'
               indicatorSeparatorDisplay='none'
               placeholderColor='#C6C6C6'
               valueContainerColor="#797694"  
							 optionPosition='justify-content-start'
               menuListPaddingX='px-2'
               okButtonPaddingEnd='pe-2'
               data-testid='oem-model-filter'
               />
          </div>

          <div className={`col-3 multi-select-width ${!selectedCity? 'no-value-selected' : ''}`}
                style={{display: filterType === Report_Filter_Type.OEM_MODEL_CITY ? 'block': 'none'}}>
                  <SingleSelect
                        placeholder="City"
                        options={mappedOptions.location}
                        selectedOptions={selectedCity}
                        onSelectHandler={(value) => {setSelectedCity(value); onSelectionChange(); }}
                        customBackgroundColor="#EFF3F7"
                        data-testid='city-filter'
                        minHeight={'45px'}
                        optionPosition="ps-2 justify-content-start"
                        valueContainerJustifyContent="start"
                        singleValueColor="#1F2A5D"
                        menuMaxheight="225px"
                  /> 
           </div>

           <div className={`col-3 multi-select-width ${!startDate? 'no-value-selected' : ''}`}>
           <DatePicker
              onDateChange={(dates) => {onDateChange(dates); onSelectionChange();}}
              allowedMaxDaysInSelection={31}
              paddingLeft='0px'
              clearDateSelectionOnToggle={clearDateSelection}
              data-testid='daterange-filter'
              customBackgroundColor='#EFF3F7'
          />
           </div>

          <div className='col-1'>
            <Button
              data-testid='get-report-button'
              className="bttn height"
              id="getReport"
              type="submit"
              onClick={onSubmitHandler}
              disabled={isDisabled()}
            >
              Get Report
            </Button>
          </div>

          <div className='col-1 export-btn-box'>
            <button
              data-testid='export-button'
              disabled={
                !allChargingSessions?.length
              }
              className={
                !allChargingSessions?.length
                  ? 'dwn-btn dwn-btn-disabled'
                  : 'dwn-btn'
              }
              onClick={() => {
                exportToExcel()
              }}
            >
              <BsDownload style={{width:'22px',height:'22px'}}/>
            </button>
          </div>
        </div>

        {allChargingSessions?.length ? (
          <div className="bg-white mb-2 mt-4 position-relative trip__log__table">
            <Table responsive={true} borderless className="mb-0">
              <thead>
                <tr className="th-border-bottom">
                  <th className="ps-2 text-nowrap"><span className='fw500'>S.No</span></th>
                  <th className="ps-2 text-nowrap"><span className='fw500'>Vehicle No.</span></th>
                  <th className="ps-2 text-nowrap"><span className='fw500'> OEM & Model</span></th>
                  <th className="ps-2 text-nowrap"><span className='fw500'>SoC Charged</span></th>
                  <th className="ps-2 text-nowrap"><span className='fw500'>Duration</span></th>
                  <th className="ps-2 text-nowrap"><span className='fw500'>GPS</span></th>
                </tr>
              </thead>
              <tbody>
                {allChargingSessions?.map((n, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        {index +
                          1 +
                          ((currentPage - 1) * 10 +
                            (currentPage - 1) * (ITEMS_PER_PAGE - 10)) +
                          '.'}
                      </td>
                      <td>
                          {n?.registration_number}
                          {n?.nrn ?
                          <VehicleNRNTooltip
                            parameter1 = {n.nrn}
                         />
                        : " "}
                          <BreakdownBadge registrationNumber={n?.registration_number} />
                      </td>
                      <td>{n?.oem} {n?.model}</td>
                      <td>
                        <div className="d-flex flex-row gap-1 align-items-center justify-content-center">
                          {(n.socCharged ? Math.round(n.socCharged) : 0) + '%'}
                          <OverlayTrigger
                            placement="auto-end"
                            delay={{ show: 0, hide: 0 }}
                            overlay={renderTooltip({
                              parameter1: 'Start SoC',
                              parameter2: 'End SoC',
                              unit: '%',
                              start: n.startSoC,
                              end: n.endSoC,
                            })}
                          >
                            <button className="row-btn">
                              <BiInfoCircle className="row-i-icon" />
                            </button>
                          </OverlayTrigger>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex flex-row gap-1 align-items-center justify-content-center">
                          {n.duration}
                          <OverlayTrigger
                            placement="auto-end"
                            delay={{ show: 0, hide: 0 }}
                            overlay={renderTooltip({
                              parameter1: 'Start Time',
                              parameter2: 'End Time',
                              start: getFormattedDate(n.startDateTime),
                              end: getFormattedDate(n.endDateTime),
                            })}
                          >
                            <button className="row-btn">
                              <BiInfoCircle className="row-i-icon" />
                            </button>
                          </OverlayTrigger>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex flex-row gap-1 align-items-center justify-content-center">
                          <img
                            src="/images/svgicon/location.svg"
                            alt="location"
                            style={{
                              width: 18,
                              cursor: "pointer"
                            }}
                            data-testid={`gps-button-${n?.registration_number}`}
                            onClick={() => handleMapCoOrdinateClick({
                              lat: parseFloat(n?.gps?.split(',')[0]),
                              lng: parseFloat(n?.gps?.split(',')[1])
                            })}
                          ></img>
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
            <Pagination
              disabled={false}
              totalPages={Math.ceil((dataCount || 0) / ITEMS_PER_PAGE)}
              currentPage={currentPage}
              setPage={setCurrentPage}
              data-testid='charging-pagination'
            />
          </div>
        ) : (
          <></>
        )}
        {!allChargingSessions?.length && isSubmitClicked && !isLoading ? (
          <NoRecordFound></NoRecordFound>
        ) : (
          <></>
        )}
      </Container>
      <Loader isLoading={isLoading} />
      {
        showPopup
        &&
        <div id="popup1" className={`popup ${showPopup ? "open" : ""}`}>
          <div className="popup-overlay" data-testid='gps-dialog-toggle' onClick={togglePopup}></div>
          <div className="popup-content">
            <MapAdddressByLocation isOpen={showPopup} toggleModal={togglePopup} CoOrdinates={coordinate} data-testid='charging-gps-dialog' />
          </div>
        </div>
      }
    </>
  )
}
Charge.propTypes = {
  allChargingSessions: PropTypes.array.isRequired,
  dataCount: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,

  // Action props
  getAllChargeSessions: PropTypes.func.isRequired,
  ExportChargingSessionsReport: PropTypes.func.isRequired,
  subscribedByCI: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
}

const mapStateToProps = (state) => ({
  allChargingSessions: state.chargingSessions.allChargingSessions,
  dataCount: state.chargingSessions.dataCount,
  isLoading: state.loader.isLoading,
  masterLocationData: state.getAllUserRoleReducer.masterLocationData,
  subscribedByCI: state.vehicle.subscribedVehiclesByCI,
})

export default connect(mapStateToProps, {
  getAllChargeSessions,
  ExportChargingSessionsReport,
  GetUserRoleList
})(Charge)
